import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import "../css/SessionExpiredPopup.css";
import { useLogout } from "services/LogoutProvider";

const UnauthorizedPopup: React.FC = () => {
  const { isUnauthorized, handleUnauthorizedConfirm } = useLogout();
  return (
    <Dialog
      open={isUnauthorized}
      onClose={handleUnauthorizedConfirm}
      PaperProps={{
        className: "session-expired-popup-container",
      }}
      BackdropProps={{
        className: "session-expired-popup-backdrop",
      }}
    >
      <DialogContent sx={{ padding: 0, margin: 0 }}>
        <div className="session-expired-popup-header">Unauthorized Access</div>
        <div className="session-expired-popup-divider"></div>
        <div className="session-expired-popup-containt-container">
          <p>
            You do not have the required permission to access this application.
          </p>
        </div>
        <div
          className="session-expired-popup-button"
          onClick={handleUnauthorizedConfirm}
        >
          <div>Okay</div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default UnauthorizedPopup;
